var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14644 7.64982C5.05281 7.74357 5.00022 7.87065 5.00022 8.00315C5.00022 8.13565 5.05281 8.26274 5.14644 8.35649L10.1464 13.3565C10.2412 13.4448 10.3666 13.4929 10.4961 13.4906C10.6257 13.4883 10.7492 13.4358 10.8409 13.3442C10.9325 13.2526 10.9849 13.129 10.9872 12.9995C10.9895 12.87 10.9414 12.7446 10.8531 12.6498L6.20644 8.00315L10.8531 3.35649C10.9414 3.2617 10.9895 3.13634 10.9872 3.0068C10.9849 2.87727 10.9325 2.75368 10.8409 2.66207C10.7492 2.57046 10.6257 2.51799 10.4961 2.5157C10.3666 2.51342 10.2412 2.5615 10.1464 2.64982L5.14644 7.64982Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.ad8799685b8ff657671c1a7b86ccc6af.svg";
export { ForwardRef as ReactComponent };